import { useStore } from 'effector-react'
import { $currencies } from './model'

export const useAllTransactionList = () => {
  const currencies = useStore($currencies)
  return {
    currencies,
  }
}
